import { Link } from 'react-router-dom';
export default function NotFound() { return <section className="legal-content container-narrow"><h1>Page introuvable</h1><p>Cette page n’existe pas ou a été déplacée.</p><Link className="button button-primary" to="/">Retour à l’accueil</Link></section>; }
